import React from 'react';

const Manual = () => {
  return (
    <div>
      <h1>Hello world</h1>
      <input type="text" />
    </div>
  );
};

export default Manual;
